import React from 'react';
import FormModal from './FormModal';
import axios from 'cccisd-axios';
import notification from 'cccisd-notification';
import Confirm from 'cccisd-confirm';
import Tooltip from 'cccisd-tooltip';
import BinIcon from 'cccisd-icons/bin';
import style from './style.css';
const Boilerplate = window.cccisd.boilerplate;

const UpdateButton = ({ value, row, reloadTable, loadData, options, session }) => (
    <div className={style.spaceRight}>
        <FormModal
            isEdit
            value={value}
            row={row}
            reloadTable={reloadTable}
            loadData={loadData}
            options={options}
            session={session}
        />
    </div>
);

const Actions = props => {
    const deletePawn = () => {
        Confirm({
            message: 'Confirm Delete',
            description: 'Are you sure you wish to delete this contact?',
            confirmLabel: 'Delete',
            abortLabel: 'Cancel',
        })
            .then(async () => {
                try {
                    const response = await axios.delete(
                        Boilerplate.route('api.nexus.pawn.destroy', {
                            pawn: props.row['pawn.pawnId'],
                            pawnHash: props.row['pawn.pawnHash'],
                        })
                    );

                    if (response?.data?.status === 'success') {
                        notification('Contact was deleted!');
                        props.reloadTable();
                        props.loadData();
                    } else {
                        notification({ message: 'An error occured deleting contact', type: 'danger' });
                    }
                } catch (e) {
                    console.error(e);
                }
            })
            .fail(() => {
                // nothing
            });
    };

    return (
        <div style={{ display: 'flex' }}>
            <Tooltip title="Update Contact" placement="top">
                <UpdateButton {...props} />
            </Tooltip>
            <Tooltip title="Delete Contact" placement="top">
                <button type="button" className="btn btn-sm btn-danger" onClick={deletePawn}>
                    <BinIcon />
                </button>
            </Tooltip>
        </div>
    );
};

export default Actions;
